module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('header', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.header)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "page-body"
  }, _vm._l((_vm.body), function(el, key2) {
    return _c('div', {
      key: key2,
      staticClass: "page-block",
      domProps: {
        "innerHTML": _vm._s(el)
      }
    })
  }), 0), _vm._v(" "), _c('footer', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.footer)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-number"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28363a26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document/DocumentPage.vue
// module id = 667
// module chunks = 0